import React from "react";

export default function ResourcesFilterBar({
  searchInput,
  onSearchChange,
  onSearchSubmit,
  onClearAll,
  hasActiveFilters,
}) {
  return (
    <section
      className="twentytwentysix-content__section twentytwentysix-content__filter-bar twentytwentysix-content__mlist-top-filters"
      aria-label="Search articles"
    >
      <form
        className="twentytwentysix-content__search-form"
        onSubmit={onSearchSubmit}
        aria-label="Search articles"
      >
        <input
          type="search"
          className="twentytwentysix-content__filter-input"
          placeholder="Search by title, topic, or tag…"
          value={searchInput}
          onChange={(e) => onSearchChange(e.target.value)}
          aria-label="Search resources"
        />
        <button
          type="submit"
          className="twentytwentysix-content__pill twentytwentysix-content__pill--small"
        >
          Search
        </button>
        {hasActiveFilters && (
          <button
            type="button"
            className="twentytwentysix-content__pill twentytwentysix-content__pill--outline twentytwentysix-content__mlist-clear-filters"
            onClick={onClearAll}
          >
            Clear all filters
          </button>
        )}
      </form>
    </section>
  );
}

